import css from './style.css'
import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridItem } from '../../components/grid'
import SelectMulti from '../select-multi'

class SelectShapes extends SelectMulti {
  render () {
    const value = this.props.value || []
    const linkCss = props => {
      if (props.listFor === 'primary_diamond') {
        return css.linkPrimaryDiamond
      } else if (props.listFor === 'multi_stone') {
        return css.linkMultiStone
      } else {
        return css.linkDiamondSearch
      }
    }
    let optionClassNames, disabled
    return (
      <Grid customStyle={css.group}>
        {this.props.shapes.map(shape => {
          disabled = this.props.disabled && this.props.disabled.includes(shape.value)
          optionClassNames = [
            linkCss(this.props),
            value.includes(shape.value) ? css.active : '',
            disabled ? css.disabled : ''
          ]
          return (
            <GridItem nopad className={css.shape} key={shape.value} col={`1/${this.props.shapes.length}`} customStyle={css.shapeCustomStyle}>
              <a
                id={`${this.props.id}-${shape.value}`}
                className={optionClassNames.join(' ')}
                onClick={disabled ? null : this.toggleVal.bind(this, shape.value)}>
                <div className={css.imageBox}>
                  <img
                    title={shape.label}
                    className={css.image}
                    src={require(`./images/${shape.label}.png`)}
                    srcSet={[
                      require(`./images/${shape.label}.png`) + ' 1x',
                      require(`./images/${shape.label}@2x.png`) + ' 2x'
                    ].join(', ')}
                  />
                </div>
              </a>
              <span className={css.label}>{shape.label}</span>
            </GridItem>
          )
        }, this)}
      </Grid>
    )
  }
}

SelectShapes.propTypes = {
  options: PropTypes.any, // override SelectMulti options propType
  disabled: PropTypes.arrayOf(PropTypes.string)
}

export default SelectShapes



// WEBPACK FOOTER //
// ./src/components/select-shapes/index.js